import { LaboHelmet } from '~/icons/LaboHelmet'
import { LaboGear } from '~/icons/LaboGear'
import { LaboLeaf } from '~/icons/LaboLeaf'
import { LaboLeaf2 } from '~/icons/LaboLeaf2'
import { LaboFlame } from '~/icons/LaboFlame'
import { LaboGreenGas } from '~/icons/LaboGreenGas'
import { LaboGnv } from '~/icons/LaboGnv'
import { LaboHydrogen } from '~/icons/LaboHydrogen'
import { LaboBuilding } from '~/icons/LaboBuilding'
import { LaboMarket } from '~/icons/LaboMarket'
import { LaboMethane } from '~/icons/LaboMethane'
import { LaboTank } from '~/icons/LaboTank'
import { LaboPipe } from '~/icons/LaboPipe'
import { LaboPipe2 } from '~/icons/LaboPipe2'
import { LaboPipe3 } from '~/icons/LaboPipe3'
import { LaboBulb } from '~/icons/LaboBulb'

export const LABO_ICONS = {
  ampoule: LaboBulb,
  tuyaux3: LaboPipe3,
  casque: LaboHelmet,
  engin: LaboGear,
  feuille: LaboLeaf,
  feuille2: LaboLeaf2,
  flamme: LaboFlame,
  'gaz vert': LaboGreenGas,
  gnv: LaboGnv,
  hydrogène: LaboHydrogen,
  immeuble: LaboBuilding,
  marché: LaboMarket,
  méthane: LaboMethane,
  tank: LaboTank,
  tuyaux: LaboPipe,
  tuyaux2: LaboPipe2,
}
